import React from "react";

export const ArrowUpIcon = React.memo(({color = "var(--messenger-grey-2)"}: any) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.5 13.75L10 6.25L2.5 13.75" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
});